import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Tooltip,
  Typography,
} from '@mui/material';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useAuthContext } from 'src/context/AuthContextProvider';
import { getFiagroTotalizers } from 'src/services/operation/operationFiagro';

export default function Totalizers() {
  const { auth } = useAuthContext();
  const hasPermission = Boolean(
    auth?.user?.subscription?.plan?.permissions?.operacoes_visao_basica,
  );
  const { data, isLoading } = useQuery({
    queryKey: ['fiagro-totalizers'],
    queryFn: () => getFiagroTotalizers(),
    enabled: hasPermission,
    onError: () => {
      toast.error('Erro ao carregar totalizers');
    },
  });

  function formatValue(value: number) {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return formatter.format(Number(value));
  }

  if (!hasPermission || (!isLoading && !data?.length)) {
    return null;
  }

  if (isLoading) {
    return (
      <Box
        display="flex"
        gap={2}
        flexWrap={{ xs: 'wrap', md: 'nowrap' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
        flex={{ xs: 1, sm: 'auto' }}>
        <Skeleton animation="wave" variant="rounded" width={200} height={90} />
        <Skeleton animation="wave" variant="rounded" width={200} height={90} />
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      gap={2}
      flexWrap={{ xs: 'wrap', md: 'nowrap' }}
      flexDirection={{ xs: 'column', sm: 'row' }}
      flex={{ xs: 1, sm: 'auto' }}>
      {data?.map((totalizer) => (
        <Tooltip
          placement="top"
          arrow
          key={totalizer.title}
          title={
            totalizer?.meta === 'currency'
              ? formatValue(totalizer.rawValue ?? 0)
              : totalizer.value
          }>
          <Card
            key={totalizer.title}
            elevation={2}
            sx={{ bgcolor: 'grey.100', minWidth: { xs: '100%', sm: '200px' } }}>
            <CardHeader
              title={
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  fontWeight="500">
                  {totalizer.title}
                </Typography>
              }
              sx={{
                py: 1,
              }}
            />
            <CardContent sx={{ py: 1, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h5" flexWrap="wrap">
                {totalizer.value}
              </Typography>
            </CardContent>
          </Card>
        </Tooltip>
      ))}
    </Box>
  );
}
